import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=a913050e&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=a913050e&prod&scoped=true&lang=css"
import style1 from "./Chat.vue?vue&type=style&index=1&id=a913050e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a913050e",
  null
  
)

export default component.exports